import React from "react";
import SvgIcon from "@material-ui/core/SvgIcon";

interface IProps {
  className?: string;
}

const ConditionsHintIcon = (props: IProps) => {
  const { className } = props;

  return (
    <SvgIcon className={className} viewBox="-4 -3 24 24">
      <g
        xmlns="http://www.w3.org/2000/svg"
        transform="matrix(1 0 0 1 -1618 -332 )"
      >
        <path
          d="M 7.2 11.2  L 7.2 12.8  L 8.8 12.8  L 8.8 11.2  L 7.2 11.2  Z M 16 8  C 16 3.584  12.416 0  8 0  C 3.584 0  0 3.584  0 8  C 0 12.416  3.584 16  8 16  C 12.416 16  16 12.416  16 8  Z M 14.4 8  C 14.4 11.528  11.528 14.4  8 14.4  C 4.472 14.4  1.6 11.528  1.6 8  C 1.6 4.472  4.472 1.6  8 1.6  C 11.528 1.6  14.4 4.472  14.4 8  Z M 11.2 6.4  C 11.2 4.632  9.768 3.2  8 3.2  C 6.232 3.2  4.8 4.632  4.8 6.4  L 6.4 6.4  C 6.4 5.52  7.12 4.8  8 4.8  C 8.88 4.8  9.6 5.52  9.6 6.4  C 9.6 8  7.2 7.8  7.2 10.4  L 8.8 10.4  C 8.8 8.6  11.2 8.4  11.2 6.4  Z "
          fill="#7f7f7f"
          stroke="none"
          transform="matrix(1 0 0 1 1618 332 )"
        />
      </g>
    </SvgIcon>
  );
};

export default ConditionsHintIcon;
